export enum ContentTypes {
  TEST = 'AdvizedTest',
  TOPLIST = 'AdvizedToplist',
  TOPLIST_HEADLINE = 'ToplistHeadline',
  GUIDE = 'ExpertGuide',
  ARTICLE = 'SearchArticleItem',
}

export enum ExpertUserCardSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
}
